import { render, staticRenderFns } from "./openservice.vue?vue&type=template&id=7df50d24&"
import script from "./openservice.vue?vue&type=script&lang=js&"
export * from "./openservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports